export enum SegmentEditorState {
    Translate = 1,
    Merge,
    Split,
}